import { ProcessType } from '@etp/etp-gain-bff-client/axios';

interface CheckboxConfig {
  show: boolean;
  disabled: boolean;
  default: boolean;
}

export interface ProcessTypeConfig {
  labelKey: string;
  disableLogicType: boolean;
  maxFiles: number | null;
  checkboxConfig: {
    required: CheckboxConfig;
    trigger: CheckboxConfig;
    versioned: CheckboxConfig;
    archived: CheckboxConfig;
  };
}

const processTypeConfigs: Record<number, ProcessTypeConfig> = {
  [ProcessType.GainData]: {
    labelKey: 'gainPreprocessor',
    disableLogicType: false,
    maxFiles: null,
    checkboxConfig: {
      required: { show: true, disabled: false, default: false },
      trigger: { show: true, disabled: false, default: false },
      versioned: { show: true, disabled: false, default: false },
      archived: { show: true, disabled: false, default: false }
    }
  },
  [ProcessType.FxRate]: {
    labelKey: 'fxRate',
    disableLogicType: true,
    maxFiles: 1,
    checkboxConfig: {
      required: { show: true, disabled: true, default: true },
      trigger: { show: true, disabled: true, default: true },
      versioned: { show: false, disabled: false, default: false },
      archived: { show: true, disabled: false, default: false }
    }
  },
  [ProcessType.MobilityFlagging]: {
    labelKey: 'mobilityFlagging',
    disableLogicType: true,
    maxFiles: null,
    checkboxConfig: {
      required: { show: true, disabled: false, default: false },
      trigger: { show: true, disabled: false, default: false },
      versioned: { show: false, disabled: false, default: false },
      archived: { show: true, disabled: false, default: false }
    }
  }
};

export function getProcessTypeConfig(type: ProcessType): ProcessTypeConfig {
  return processTypeConfigs[type] || processTypeConfigs[ProcessType.GainData];
}

export function getAllProcessTypes(showMobilityFlagging = true): Array<{
  value: number;
  labelKey: string;
}> {
  return Object.entries(ProcessType)
    .filter(([, value]) => {
      if (value === ProcessType.MobilityFlagging && !showMobilityFlagging) {
        return false;
      }
      return true;
    })
    .map(([key, value]) => ({
      value: value as number,
      labelKey: processTypeConfigs[value as number]?.labelKey || key
    }));
}
